var loqate = new function () {
    this.xhr;
    this.cache = {};

    this.doKeydown = function (event, element) {
        var keyCode = (event.keyCode ? event.keyCode : event.which),
        	$form = loqate.getContainer(element);
        if (($(element).hasClass('loqate-field-postcode') || $(element).is('button')) && !$(element).closest('.loqate-postcode').hasClass('address-found')) {
        	event.stopPropagation();
			if (keyCode == 13 || keyCode == 1) {
				if ($form.find('.loqate-results-list').find('.is-selected').length) {
					$form.find('.loqate-results-list').find('.is-selected a').trigger('click');
				} else {
					loqate.doSearch(event, element);
				}
			} else if (keyCode == 38 || keyCode == 40) {
				this.doSetSelected(keyCode);
			}
		}
    };
    this.doSearch = function (event, element) {
        var keyCode = (event.keyCode ? event.keyCode : event.which);
		if (keyCode == 13 || keyCode == 1) {
		 	loqate.getUrl(event, $(element).parent().find('.loqate'));
		};
    };
    this.doHideError = function ($form) {
    	$form.find('.loqate-postcode-error').remove();
	};
    this.doShowError = function ($form, errorMessage) {
    	this.doHideError($form);
    	$form.find('.form-item.loqate-postcode').after('<div class="form-item loqate-postcode-error has-error"><span class="form-item__message">' + errorMessage + '</span></div>');
	};
	this.doHideFieldError = function ($form, field) {
		$form.find('.loqate-field-' + field + '-error').remove();
		$form.find('.loqate-field-'+field).parent('.form-item').removeClass('has-error');
	};
	this.doShowFieldError = function ($form, field, errorMessage) {
		$form.find('.loqate-field-'+field).after('<div class="form-item loqate-field-' + field + '-error has-error"><span class="form-item__message">' + errorMessage + '</span></div>');
		$form.find('.loqate-field-'+field).parent('.form-item').addClass('has-error');
	};
    this.getUrl = function (event, element) {
		var $form = loqate.getContainer(element),
			$formItem = $(element).closest('.form-item'),
			text, // Postcode
			$container;
		$formItem.find('.form-item__message').remove();
		if ($(element).data('loqate-text')) {
			text = ($(element).data('loqate-text'));
		} else {
			text = $(element).val();
		}
		if ($(element).data('loqate-container')) {
			$container = $(element).data('loqate-container');
		}
		if (text.length < 3) {
			this.doShowError($form, 'Please enter a postcode');
		} else {
			if ($(element).data('loqate-type') && $(element).data('loqate-type') == 'Address' && $container !== '') {
				this.getAddress(event, element);
			} else {
				this.setLoading($form, element, true);
				var cacheKey = text + ($container ? 'container' : '');
				if (typeof loqate.cache[cacheKey] != 'undefined') {
					loqate.doResponse($form, element, loqate.cache[cacheKey]);
				} else {
					if (typeof this.xhr == 'object') this.xhr.abort();
					this.xhr = $.ajax({
						type: 'POST',
						url: '/wp-admin/admin-ajax.php',
						dataType: 'json',
						data: {
							action: 'flogas_loqate_get',
							text: text,
							container: $container,
							_wpnonce: $form.find('.loqate').data('nonce')
						},
						success: function (json) {
							loqate.cache[cacheKey] = json;
							loqate.doResponse($form, element, json);
						},
						error: function (xhr, ajaxOptions, thrownError) {
							loqate.setLoading($form, element, false);
						}
					});
				}
			}
		}
    };
	this.doResponse = function ($form, element, json) {
		var $resultsList = $form.find('.loqate-results-list');
		if (!$resultsList.length) {
			$form.find('.loqate-postcode').after($('<ul class="loqate-results-list"></ul>'));
			$resultsList = $form.find('.loqate-results-list');
		}
		$resultsList.empty().removeClass('hide');
		if (json.data.api_error) {
			console.error(json.data.api_error);
		}
		if (json.data.error_message) {
			loqate.doShowError($form, json.data.error_message);
		} else if (json.data.addresses.length) {
			$.each(json.data.addresses, function (i, item) {
				$resultsList.append('<li class="loqate-result"><a data-click="loqate:getUrl" data-key-up="locate:doKeyUp" class="loqate-result__link" data-loqate-type="' + item.Type + '" data-loqate-text="' + item.Text + '" data-loqate-container="' + item.Id + '">' + item.Text + '<span class="loqate-result__extra-info">' + item.Description + '<span></a></li>');
			});
			$form.find('.loqate-postcode').find('input').focus();
		} else {
			loqate.doShowError($form, 'Couldn\'t find your postcode');
		}
		loqate.setLoading($form, element, false);
	};
	this.getAddress = function (event, element) {
		if (typeof this.xhr == 'object') this.xhr.abort();
		var $form = loqate.getContainer(element);
		this.setLoading($form, element, true);

		this.xhr = $.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: {
				action: 'flogas_loqate_get',
				addressId: $(element).data('loqate-container'),
				_wpnonce: $form.find('.loqate').data('nonce')
			},
			success: function (json) {
				loqate.doValidate($form);
				$form.find('.loqate-address__lookup-again').removeClass('hide');
				if (json.data.address.addressLine1) {
					$form.find('.loqate-field-address-line-1').val(json.data.address.addressLine1).trigger('change');
				}
				if (json.data.address.addressLine2) {
					$form.find('.loqate-field-address-line-2').val(json.data.address.addressLine2).trigger('change');
				}
				if (json.data.address.town) {
					$form.find('.loqate-field-town-city').val(json.data.address.town).trigger('change');
				}
				if (json.data.address.county) {
					$form.find('.loqate-field-county').val(json.data.address.county).trigger('change');
				}
				$form.find('.loqate-field-country').val('United Kingdom').trigger('change');
				if (json.data.address.postcode) {
					$form.find('.loqate-field-postcode').val(json.data.address.postcode).trigger('change');
				}
				loqate.doManual(event, element);
				loqate.setLoading($form, element, false);
			},
			error: function (xhr, ajaxOptions, thrownError) {
				loqate.setLoading($form, element, false);
			}
		});
	};
    this.doManual = function (event, element) {
		var $form = loqate.getContainer(element);
		this.doHideError($form);
		this.doValidate($form);
		$form.find('.form__alert').remove();
		$form.find('.loqate-address__enter-manually').addClass('hide');
		$form.find('.loqate-results-list').empty().addClass('hide');
		$form.find('.loqate-address-fields').removeClass('collapse');
		$form.find('.loqate-field-address-line-1, .loqate-field-address-line-2, .loqate-field-town-city, .loqate-field-county').removeAttr('tabindex');
		$form.find('.loqate-postcode').addClass('address-found').removeClass('form-item--append').find('.button').hide();
	};
	this.doLookupAgain = function (event, element) {
		var $form = loqate.getContainer(element);
		$form.find('.form__alert').remove();
		$form.find('.loqate-address__enter-manually').removeClass('hide');
		$form.find('.loqate-results-list').empty().addClass('hide');
		$form.find('.loqate-address__lookup-again').addClass('hide');
		$form.find('.loqate-address-fields').addClass('collapse');
		$form.find('.loqate-field-address-line-1, .loqate-field-address-line-2, .loqate-field-town-city, .loqate-field-county').attr('tabindex', '-1');
		$form.find('.loqate-field-address-line-1, .loqate-field-address-line-2, .loqate-field-town-city, .loqate-field-county').val('');
		$form.find('.loqate-postcode').removeClass('address-found').addClass('form-item--append').find('.button').show();
	};
	this.getContainer = function (element) {
		if ($(element).closest('.loqate-container').length) {
			return $(element).closest('.loqate-container');
		} else if ($(element).closest('.loqate-postcode-container').length) {
			return $(element).closest('.loqate-postcode-container');
		} else {
			return $(element).closest('form');
		}

	};
	this.setLoading = function ($form, element, loading) {
		$form.find('.loqate-postcode').closest('.loqate-postcode-container')[(loading ? 'add' : 'remove') + 'Class']('loading');
		$form.find('.loqate-postcode').find('input, button').prop('disabled', loading);
		if (!loading) {
			$form.find('.loqate-postcode').find('input').focus();
		}
	};
    this.doSetSelected = function (keyCode) {
        var $resultsList = $('.loqate-results-list'),
            lis = $resultsList.find('li'),
            selected_index = ($resultsList.find('.is-selected').length ? $resultsList.find('.is-selected').index() : null);
        if (keyCode == 40) { // Down
            if (selected_index == null) {
                selected_index = 0;
            } else {
                selected_index++;
                if (selected_index >= lis.length) selected_index = 0;
            }
        } else {
            if (selected_index == null) {
                selected_index = (lis.length - 1);
            } else {
                selected_index--;
                if (selected_index < 0) selected_index = (lis.length - 1);
            }
        }
        lis.removeClass('is-selected');
        lis.eq(selected_index).addClass('is-selected');
    };
	this.doValidate = function ($form) {
		[ 'address-line-1', 'address-line-2', 'town-city', 'county', 'country', 'postcode' ].forEach(function (field) {
			$form.find('.loqate-field-'+field).on('input change', null, {form: $form, field: field}, loqate.onFieldChange);
		});
	};
	this.onFieldChange = function (event) {
		loqate.doHideFieldError(event.data.form, event.data.field);
		if ($(this).val().length > 30) {
			loqate.doShowFieldError(event.data.form, event.data.field, 'Please ensure field is max. 30 characters');
		}
		// Disable the submit button if within Gravity Forms.
		if ($(this).closest('.gform-body').length) {
			var $gfForm = $(this).closest('form');
			$gfForm.find('.gform_footer .button, .gform_page_footer .button')
				.filter('[id^="gform_submit_button_"], [id^="gform_next_button_"]')
				.prop('disabled', $gfForm.find('.loqate-address-fields .form-item.has-error').length);
		}
	}
};